export const RAGE_CLICK = 'rageClick';

export const ERROR_CLICK = 'errorClicks';

export const DEAD_CLICK = 'deadClicks';

export const TRENDING_DOWN = 'trendingDown';

export const TRENDING_UP = 'trendingUp';

export const FIRST_TIME_USE = 'firstTimeUse';

export const RELEVANCE = 'relevance';

export const INSIGHT_CATEGORIES = {
    TRENDING_UP,
    TRENDING_DOWN,
    RAGE_CLICK,
    ERROR_CLICK,
    DEAD_CLICK,
    FIRST_TIME_USE,
    RELEVANCE,
};

export const FRUSTRATION_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK];

export const DATE_DEPENDENT_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK, FIRST_TIME_USE];

export const INSIGHT_CARD_ICONS = {
    [TRENDING_UP]: 'trending-up',
    [TRENDING_DOWN]: 'trending-down',
    [RAGE_CLICK]: 'angry',
    [ERROR_CLICK]: 'alert-triangle',
    [DEAD_CLICK]: 'skull',
    [FIRST_TIME_USE]: 'user-plus',
};

export const INSIGHT_CARD_TYPES = {
    PLAYER: 'player',
    LIBRARY: 'library',
};

export const MIN_REPLAYS_ALLOWED = 3;

export const PAGE = 'Page';

export const FEATURE = 'Feature';

export const GUIDE = 'Guide';

export const TRACK_TYPE = 'TrackType';

export const UNSUPPORTED_INSIGHT_FILTERS = {
    [TRENDING_UP]: ['guide', 'date'],
    [TRENDING_DOWN]: ['guide', 'date'],
    [RAGE_CLICK]: ['guide', 'trackType'],
    [ERROR_CLICK]: ['guide', 'trackType'],
    [DEAD_CLICK]: ['guide', 'trackType'],
    [FIRST_TIME_USE]: ['account', 'apps', 'segment', 'visitor'],
};

export const VALUE_ACTIONS = {
    COPY_LINK: 'copy link - full replay',
    COPY_LINK_CLIP: 'copy link - clip',
    SAVE_CLIP: 'save clip',
    ADD_TO_PLAYLIST: 'add to playlist',
    CREATE_ISSUE: 'create issue',
    CREATE_FUNNEL: 'create funnel',
    CREATE_DX: 'create dx report',
};

export const SUGGESTED_REPLAY_FEEDBACK_ACTIONS = {
    DISLIKE: 'dislike',
    LIKE: 'like',
};

export const SUGGESTED_REPLAY_FEEDBACK_TRACK_EVENT = 'suggestedReplayFeedback';

export const SUGGESTED_REPLAY_DISLIKE_OPTION_KEYS = {
    NOT_ACCURATE_OR_TRUSTWORTHY: 'notAccurateOrTrustworthy',
    DETAILS_FELT_INSIGNIFICANT: 'detailsFeltInsignificant',
    OBVIOUS_OR_ALREADY_KNOWN: 'obviousOrAlreadyKnown',
    NOT_RELEVANT_TO_PRODUCT_AREA: 'notRelevantToProductArea',
    OTHER: 'other',
};

export const SUGGESTED_REPLAY_LIKE_OPTION_KEYS = {
    NEW_OR_UNEXPECTED: 'newOrUnexpected',
    SUSPECTED_OR_DISCUSSED: 'suspectedOrDiscussed',
    IMPORTANT_CHANGE: 'importantChange',
    RELEVANT_TO_CURRENT_WORK: 'relevantToCurrentWork',
    OTHER: 'other',
};

export const INSIGHT_TYPE_TO_IGNORED_FRUSTRATION_TYPE = {
    [RAGE_CLICK]: 'rageClick',
    [ERROR_CLICK]: 'errorClick',
    [DEAD_CLICK]: 'deadClick',
};
